import {
    useCallback,
    useState,
    useMemo,
} from 'react'

import Card from 'app/shared-components/Card'
import Button from 'app/shared-components/Button'
import SkyNetTable from 'app/shared-components/SkyNetTable'
import useContainerManagementRoutes from 'app/SkyNetRoutes/hooks/useContainerManagementRoutes'
import ButtonContainer from 'app/shared-components/ButtonContainer'
import {
    LaneGroupTemperatureRange,
} from 'app/enums/label.enums'

import containerRequests, {
    ContainerQueryNames,
} from 'app/requests/Container/Container.requests'
import useBookContainers from '../../hooks/useBookContainers'

import getConfig from './availableContainers.config'
import useStyles from './AvailableContainers.styles'

const AvailableContainers = ({
    id,
    onSuccess,
    tempRange,
}: {
    id: number,
    onSuccess: () => void,
    tempRange: LaneGroupTemperatureRange[],
}) => {
    const {
        classes,
    } = useStyles()

    const [
        value,
        setValue,
    ] = useState<number[]>([])

    const {
        Containers: ContainersRoutes,
    } = useContainerManagementRoutes()

    const {
        mutate,
        isPending: isLoading,
    } = useBookContainers(onSuccess)

    const tableConfig = useMemo(() => {
        return getConfig({
            availableContainersLinkConfig: {
                path: ContainersRoutes.Overview.path,
                params: {
                    key: 'serialNumber',
                },
            },
        })
    }, []) // eslint-disable-line

    const onSelectRow = useCallback((selectedIds: number[]) => {
        setValue(selectedIds)
    }, [])

    const addToDedicated = () => {
        mutate({
            id,
            data: value?.map((containerId) => {
                return {
                    id: containerId,
                }
            }),
        })
    }

    const filterTable = useMemo(() => {
        return {
            tempRange: tempRange?.length ? tempRange : undefined,
        }
    }, [tempRange])

    const customUrl = useMemo(() => {
        return containerRequests.filterRequest({
            queryName: ContainerQueryNames.longtermleaseavailable,
        }).url
    }, [])

    return (
        <Card title="Available Containers">
            <SkyNetTable
                name="ContainerView"
                selectedRows={value}
                onSelectRow={onSelectRow}
                simple
                uniqField="id"
                customUrl={customUrl}
                className={classes.root}
                tableConfig={tableConfig}
                filter={filterTable}
                showSearch
            />
            <ButtonContainer>
                <Button
                    label="add to dedicated containers"
                    onClick={addToDedicated}
                    disabled={!value.length}
                    saving={isLoading}
                    data-testid="btn-dedicated-containers"
                />
            </ButtonContainer>
        </Card>
    )
}

export default AvailableContainers
